import React from 'react';
import { Button, Card, Text } from '@fragments';
import { IconArrowsExchange, IconChevronDown } from '@tabler/icons-react';
import './styles.scss';

const DETAILS = [
    { label: 'Tax (2%)', value: '€1.88' },
    { label: 'Exchange fee (1%)', value: '€0.94' },
    { label: 'Total amount', value: '€ 91,18', strong: true },
];

export default function Exchange() {
    return (
        <Card
            flat
            title="Exchange"
            icon={<IconArrowsExchange />}
            action={
                <Button variant="text" color="inverse" size="small">
                    Currencies
                </Button>
            }
        >
            <div className="exchange">
                <div className="exchange__converter">
                    <div className="exchange__currencies">
                        <button type="button" className="exchange__currency">
                            <span className="exchange__flag exchange__flag--usd" />
                            <Text.label contrast={9}>USD</Text.label>
                            <IconChevronDown />
                        </button>
                        <span className="exchange__swap">
                            <IconArrowsExchange />
                        </span>
                        <button type="button" className="exchange__currency">
                            <span className="exchange__flag exchange__flag--eur" />
                            <Text.label contrast={9}>EUR</Text.label>
                            <IconChevronDown />
                        </button>
                    </div>

                    <div className="exchange__amount-block">
                        <Text.h2 weight={500} contrast={10}>$100.00</Text.h2>
                        <span className="exchange__inline-copy">
                            <Text.span contrast={6}>Available :</Text.span>
                            <Text.label contrast={9}>US$ 16.058,94</Text.label>
                        </span>
                    </div>

                    <div className="exchange__rate">
                        <span className="exchange__inline-copy">
                            <Text.caption contrast={6}>USD 1,00 =</Text.caption>
                            <Text.label contrast={9}>EUR 0,94</Text.label>
                        </span>
                    </div>
                </div>

                <dl className="exchange__details">
                    {DETAILS.map(({ label, value, strong }) => (
                        <div className="exchange__detail" key={label}>
                            <dt><Text.caption contrast={6}>{label}</Text.caption></dt>
                            <dd>
                                {strong ? (
                                    <Text.label contrast={10}>{value}</Text.label>
                                ) : (
                                    <Text.caption contrast={9}>{value}</Text.caption>
                                )}
                            </dd>
                        </div>
                    ))}
                </dl>

                <Button color="inverse" size="medium" fullWidth startIcon={<IconArrowsExchange />}>
                    Exchange
                </Button>
            </div>
        </Card>
    );
}
